/* eslint-disable camelcase */
import type { DealLinkProps } from '@uswitch/comms-ui.deal-link'
import classNames from 'classnames'
import React, { FC } from 'react'

import generateTelephone from '~/components/deal/utils/telephone'
import { Link, BuyNowLink } from '~/components/deal-card/components/cta/link'
import { SegmentProps } from '~/interfaces/types'
import { trackSegment } from '~/utils/tracking'

import styles from './styles.module.css'

interface CtaProps {
  dealLinkProps: DealLinkProps
  isMobileView: boolean
  metadata?: {
    dimension94: string | undefined
    page: string
  }
  list?: string
  dealLinkRef?: React.RefObject<HTMLDivElement>
  criticalJs: boolean
  segmentProps?: SegmentProps
}

const Cta: FC<CtaProps> = ({
  dealLinkProps,
  metadata,
  list,
  isMobileView,
  dealLinkRef,
  criticalJs = false,
  segmentProps = { product: {}, promotion: {} }
}) => {
  const { deal, position } = dealLinkProps

  const telephoneNumber = generateTelephone(deal.provider)

  const buyNowProps = {
    text: 'Buy now',
    position,
    isMobileView
  }

  const moreInfoProps = {
    href: `/broadband/more-info/${deal.productId}/`,
    text: 'More info',
    position,
    isMobileView
  }

  const hasTelephone = !!telephoneNumber

  // TEMPORARY FIX. WE DON'T WANT TO SHOW MS3 CONTACT NUMBERS ON SITE AS WE DON'T GET PAID FOR THEM
  const isMs3 = deal?.services?.broadband?.networkName === 'ms3'

  const visualRefreshTrackingMoreInfo = () => {
    trackSegment('Element Clicked', {
      element_name: `More info clicked - SKU: ${segmentProps.product.sku}`,
      element_text: 'More info clicked',
      element_type: 'button'
    })
  }

  const TelephoneNumber = () => {
    // TEMPORARY FIX. WE DON'T WANT TO SHOW MS3 CONTACT NUMBERS ON SITE AS WE DON'T GET PAID FOR THEM
    if (!hasTelephone || isMs3) return null

    return <span className={styles.telephone}>{`or call ${telephoneNumber}`}</span>
  }

  const MoreInfo = () => {
    return <Link onClick={visualRefreshTrackingMoreInfo} {...moreInfoProps} variant='link' />
  }

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.isMobileView]: isMobileView,
        [styles.hasTelephone]: hasTelephone
      })}
    >
      <BuyNowLink
        {...buyNowProps}
        dealLinkProps={dealLinkProps}
        metadata={metadata}
        list={list}
        criticalJs={criticalJs}
        dealLinkRef={dealLinkRef}
        segmentProps={segmentProps}
      />

      <TelephoneNumber />

      <MoreInfo />
    </div>
  )
}

export default Cta
